import styles from "./two-year-upsc-program.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";
import {createuser}  from "../../components/Service/sadhanaenquiry";
import dynamic from 'next/dynamic';
const Otpverification = dynamic(()=>import("../../components/Modal/Otpverification"));

const Sadhana_Form = () => {
  const[verified,setverified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalOtpstatus, setmodalOtpstatus] = useState(null);
  const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
  const [valuephno, setvaluephno] = useState(undefined);
  const [captchaerror, setcaptchaerror] = useState(undefined);

  function convertJsonStringToNumber(jsonString) {
        // Parse the JSON string to an object
        const jsonObject = JSON.parse(jsonString);
        // Iterate over the keys and convert numeric strings to numbers
        for (const key in jsonObject) {
          if (jsonObject.hasOwnProperty(key)
    && !isNaN(jsonObject[key])) {
            jsonObject[key] = Number(jsonObject[key]);
          }
        }

    return jsonObject;
}

  function onChange(value) {
    if(value==null){
      setverified(false);
    }
    else{
      setverified(true);
    }
  }

  async function handleOnSubmit(e) {
    e.preventDefault();
    if (verified) {
      const formData = {};
      formData['formType'] ="sadhanaupsc";
      formData['title']= "Sadhana UPSC CSE 2025";
      //formData.append("countryCode", "+91");

      Array.from(e.currentTarget.elements).forEach(field => {
        if (!field.name) return;
        formData[field.name] = field.value;

        
      });

      formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
      formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
      const transform={fields:{...formData}};
      console.log(transform);

       setIsLoading(true);
       createuser(transform)
           .then(response => {
              
               setModalOtp(true);
               setmodalOtpstatus(response.message);
               window.grecaptcha.reset(setverified);
               setverified(false);
               setvaluephno(undefined);
               document.getElementById("sadhanaupsc").reset();
               setIsLoading(false);
           })
           .catch(error => {
            setModalOtp(true);
            setmodalOtpstatus("failure");
            window.grecaptcha.reset(setverified);
            setverified(false);
            setIsLoading(false);
          })
    
    }
    else{
      setcaptchaerror(true);
      setTimeout(() => { 
      setcaptchaerror(false);
    }, 3000);
    }
  }

    return(
    <>
    
    {isLoading && 
   <div class="APIPreLoader" id="APIPreLoader">
      <div class="loader">Loading...</div>
   </div>
    }

    <Otpverification show={modalOtp} title={modalOtpstatus} frompage="sadhanaupsc" onHide={() => setModalOtp(false)} />
    <div className=" pt-3">
        <div className="row mx-auto pt-3" style={{background: "#FFF2F2 0% 0% no-repeat padding-box" , opacity: "1"}}>

            <div className="container pt-4 ">
                      <div className="row">
                        <div className="col-md-8 col-12 mx-auto">
                          <p className={`${styles.contactheader} `}>Sadhana UPSC CSE 2027 two year classroom programme (GSPCM)</p>
                        </div>
                      </div>

                <div className="row">

                <div className="col-md-8 col-12 mx-auto">

                <form onSubmit={handleOnSubmit} id="sadhanaupsc" autoComplete="off">

                  <div className="row pt-4">

                <div className="col-12 col-lg-4 col-xl-3 dot">
            <div className="mb-4 ">
              <input type="text" className={`${styles.acheiverrank} form-control `} placeholder="Name" autoComplete="off"  name="name" minLength="1" required/>
            </div>
          </div>

          <div className="col-12  col-lg-4 col-xl-3">
            <div className="mb-4">
              <input type="email" className={`${styles.acheiverrank} form-control`} placeholder="Email Address" title="Please enter a valid email address"  autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required/>
            </div>
          </div>

          {/* <div className="col-12  col-lg-4 col-xl-3">
            <div className="mb-4">
              <PhoneInput 
                        name='phoneNo'  
                        autoComplete="off"
                        placeholder="Enter phone number" 
                        value={valuephno}  
                        onChange={setvaluephno}  
                        international  
                        countryCallingCodeEditable={false}  
                        defaultCountry="IN" 
                        pattern="(\+[0-9]{1,4}\s[0-9\-\(\)\s]{8,13})" 
                      />
            </div>
          </div> */}

                    <div className="col-12 col-lg-3">
                      <div className="mb-4">
                        <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
                      </div>
                    </div>

          <div className="col-12  col-lg-4 col-xl-3">
            <div className="mb-4">
                <select className={`${styles.acheiverrank} form-select form-control`} id="autoSizingSelect" name="branch" autoComplete="off"  required>
                    <option value="" disabled selected hidden>Select Center</option>
                    <option value="Chennai-Annanagar">Chennai-Annanagar</option>
                    <option value="Chennai-Adyar">Chennai-Adyar</option>
                    <option value="Delhi">Delhi</option>
                    <option value="Bengaluru">Bengaluru</option>
                    <option value="Thiruvananthapuram">Thiruvananthapuram</option>
                    <option value="Trichy">Trichy</option>
                    <option value="Coimbatore">Coimbatore</option>
                    <option value="Salem">Salem</option>
                    <option value="Madurai">Madurai</option>
                    <option value="Hyderabad">Hyderabad</option>
                    <option value="Online">Online</option>
                </select>
            </div>
          </div>

          <div className="col-12 col-lg-3">
            <div className="mb-4">
              <input type="text" className={`${styles.acheiverrank} form-control`} placeholder="Query" title="Please describe your query in detail" autoComplete="off" name="query" required></input>
            </div>
          </div>

          </div>

          <div className="col-12">
            <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id={styles.invalidCheck2} />
                <label className={`${styles.checkboxcontent} form-check-label`} htmlFor="invalidCheck2">
                    I would like to receive updates from Shankar IAS Academy
                </label>
            </div>
          </div>

          <div className="d-flex flex-wrap mb-3">
          <div className="me-3 mt-2">
          <ReCAPTCHA className={`${styles.captcha}`}
          sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"   
          onChange={onChange}
          />
                    <div className="">
                      {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                    </div>
          </div>
                  <div className="my-auto">
                   <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p>
                  </div>
          </div>
          
                </form>      
                </div>
                </div>
            </div>    
        </div>
    </div>
    </>
    )
}
export default Sadhana_Form;